import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { UserContext } from '../../contexts'
import { CustomerCompany } from '../../types'
import EditIcon from '../../assets/icons/edit-icon.svg'
import AccountIcon from '../../assets/icons/account-icon.svg'
import MailGreyIcon from '../../assets/icons/mail-grey-icon.svg'
import ContactsGreyIcon from '../../assets/icons/contacts-grey-icon.svg'
import { CustomerCompanyManageDataModal } from './customer-company-manage-data-modal'

export const CustomerCompanyProfileData = ({
  handleCloseSession,
  customerCompanyData,
  customerCompanyProfile,
  // businessOwnerFileDownloadUrl,
  // businessCompanyFileDownloadUrl,
  handleOpenUpdateCustomerCompanyData
}: // handleOpenViewCustomerCompanyDocument
{
  handleCloseSession: () => void
  // businessOwnerFileDownloadUrl: string
  // businessCompanyFileDownloadUrl: string
  customerCompanyData: CustomerCompany | null
  handleOpenUpdateCustomerCompanyData: () => void
  // handleOpenViewCustomerCompanyDocument: (documentTypeToDisplay: string) => void
  customerCompanyProfile?: { balance: string; businessName: string; businessDocumentNumber: string; businessEmail: string; businessOwner: string }
}) => {
  const { userSession } = useContext(UserContext)
  const { t } = useTranslation(['customer-company-details-management'])

  const [openCustomerCompanyManageDataModal, setOpenCustomerCompanyManageDataModal] = useState<boolean>(false)

  return (
    <>
      <div className="customer-company-main-data-details-container">
        <div className="customer-company-name">{customerCompanyProfile?.businessName}</div>
        <div className="customer-company-data-container">
          <div className="customer-company-data-row-container">
            <div className="customer-company-data-left-item-container">
              <div className="subtitle-container">
                <img
                  src={MailGreyIcon}
                  alt="mail-grey-icon"
                />
                <div className="subtitle-text">{`${t('mail')}:`}</div>
              </div>
              <div className="data-container">
                <div className="data-text">{customerCompanyProfile?.businessEmail}</div>
              </div>
            </div>
            <div className="customer-company-data-right-item-container">
              <div className="subtitle-container">
                <img
                  src={ContactsGreyIcon}
                  alt="contacts-grey-icon"
                />
                <div className="subtitle-text">NIT:</div>
              </div>
              <div className="data-container">
                <div className="data-text">{customerCompanyProfile?.businessDocumentNumber}</div>
                {/* {customerCompanyData?.businessCompanyDocumentation && (
                  <div
                    onClick={(event) => {
                      event.stopPropagation()
                      if (customerCompanyData?.businessCompanyDocumentation?.documentFileSystemName.toLowerCase().indexOf('pdf') === -1) {
                        handleOpenViewCustomerCompanyDocument('company-document')
                        return
                      }

                      window.open(businessCompanyFileDownloadUrl, '_blank')
                    }}
                    className="data-action-button-container"
                  >
                    <div className="data-action-button-text">{t('viewDocument', { ns: 'customer-companies-management' })}</div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div className="customer-company-data-row-container">
            <div className="customer-company-data-left-item-container larger-data">
              <div className="subtitle-container">
                <img
                  src={AccountIcon}
                  alt="account-icon"
                />
                <div className="subtitle-text">{`${t('businessOwner')}:`}</div>
              </div>
              <div className="data-container">
                <div className="data-text">{customerCompanyProfile?.businessOwner}</div>
                {/* {customerCompanyData?.businessOwnerDocumentation && (
                  <div
                    onClick={(event) => {
                      event.stopPropagation()
                      if (customerCompanyData?.businessOwnerDocumentation?.documentFileSystemName.toLowerCase().indexOf('pdf') === -1) {
                        handleOpenViewCustomerCompanyDocument('owner-document')
                        return
                      }

                      window.open(businessOwnerFileDownloadUrl, '_blank')
                    }}
                    className="data-action-button-container button-container-larger-data"
                  >
                    <div className="data-action-button-text">{t('viewDocument', { ns: 'customer-companies-management' })}</div>
                  </div>
                )} */}
              </div>
            </div>
            {userSession?.role === 'super-admin' && (!userSession?.subRole || (userSession?.subRole && userSession?.subRole !== 'reconciliation-specialist')) && (
              <div className="customer-company-data-right-item-container smaller-data">
                <div
                  onClick={() => handleOpenUpdateCustomerCompanyData()}
                  className="edit-data-button-container"
                >
                  <img
                    src={EditIcon}
                    alt="edit-icon"
                  />
                </div>
              </div>
            )}
            {userSession?.role === 'super-admin' && userSession?.subRole && userSession?.subRole === 'compliance-specialist' && (
              <div
                style={{ width: 'auto', justifyContent: 'flex-end' }}
                className="customer-company-data-right-item-container"
              >
                <div
                  style={{ alignItems: 'center' }}
                  className="edit-data-button-container"
                  onClick={() => setOpenCustomerCompanyManageDataModal(true)}
                >
                  <img
                    src={AccountIcon}
                    alt="account-icon"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {openCustomerCompanyManageDataModal && (
        <CustomerCompanyManageDataModal
          handleCloseSession={handleCloseSession}
          customerCompanyDataToUpdate="compliance-users"
          customerCompanyId={String(customerCompanyData?._id)}
          handleCloseModal={(openStateToSet: boolean) => setOpenCustomerCompanyManageDataModal(openStateToSet)}
        />
      )}
    </>
  )
}
